import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedReimaginedBenefitsIndexRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    // Fetch all benefits-related data in parallel
    const [
      benefitsSummary,
      tasData,
      pslfData,
      employerContributions,
      section127Info,
      dataSourceInfo,
    ] = await Promise.all([
      this.reimaginedData.fetchBenefitsSummary(),
      this.reimaginedData.fetchTasData(),
      this.reimaginedData.fetchPslfData(),
      this.reimaginedData.fetchEmployerContributions(),
      this.reimaginedData.fetchSection127Info(),
      this.reimaginedData.getDataSourceInfo(),
    ]);

    return {
      benefitsSummary,
      tasData,
      pslfData,
      employerContributions,
      section127Info,
      dataSourceInfo,
    };
  }
}
